import script from "./ButtonMultiAction.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonMultiAction.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonMultiAction.vue?vue&type=style&index=0&id=5db2c2c7&lang=scss&scoped=true"

import exportComponent from "../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5db2c2c7"]])

export default __exports__